import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { NotificationBanner } from "../../../Common/NotificationBanner/NotificationMessage";
import { INotification } from "../../../Notification/Index";
import { getNotificationTextBasedOnConfig, validateIfConfigMapMessage } from "../helper";
import { CONFIGSAVE } from "../Constant";
import { OutputMappingButtonsBar } from "./OutputMappingButtonsBar/OutputMappingButtonsBar.logic";
import { OutputMappingList } from "./OutputMappingList/OutputMappingList.logic";
import { OutputMappingPopup } from "./OutputMappingPopup/OutputMappingPopup.logic";

interface IOutputMappingViewProps {
  /**
   * Notification message items that needs that are currently available in redux state
   */
  notificationItems: INotification[];
}

/**
 * Responsible for rendering output mapping
 */
export const OutputMappingView: React.FC<IOutputMappingViewProps> = (props: IOutputMappingViewProps) => {
  const { t: translate } = useTranslation();
  const notificationMessage = getNotificationTextBasedOnConfig(props.notificationItems, CONFIGSAVE);
  return (
    <div>
      <OutputMappingButtonsBar />
      {
        validateIfConfigMapMessage(notificationMessage, translate) &&
        <NotificationBanner message={notificationMessage}/>
      }
      <OutputMappingList />
      <OutputMappingPopup />
    </div>);
};
